<template>
    <h6>{{msg}}</h6>
</template>

<script>

    export default {

        name: 'JiraTaskViewer',
        props: {
            msg: String
        }
    }
</script>

<style scoped>

</style>